import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Box, Chip, Typography } from '@mui/material';
import { approveExpense, rejectExpense } from '../redux/expenseSlice';
import PdfExport from './PdfExport';

const ExpenseList = ({ isManager = false }) => {
  const expenses = useSelector((state) => state.expenses.expenses);
  const dispatch = useDispatch();

  // Fallback date in short format (e.g., "Jun 14, 2025, 01:25 PM")
  const fallbackDate = new Date().toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata', // IST timezone
  });

  // Function to shorten the expense date if it exists
  const shortenDate = (dateStr) => {
    if (!dateStr) return fallbackDate;
    // Parse the long format (e.g., "Saturday, June 14, 2025, 01:25 PM IST") and shorten it
    const date = new Date(dateStr.replace(' IST', ''));
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata',
    });
  };

  return (
    <Box sx={{ p: 2 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Amount</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>
                <Typography variant="body2" fontWeight="medium">
                  Date
                </Typography>
              </TableCell>
              {isManager && <TableCell>Actions</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {expenses.map((expense) => (
              <TableRow key={expense.id}>
                <TableCell>${expense.amount}</TableCell>
                <TableCell>{expense.description}</TableCell>
                <TableCell>{expense.category}</TableCell>
                <TableCell>
                  <Chip
                    label={expense.status}
                    color={expense.status === 'Approved' ? 'success' : expense.status === 'Pending' ? 'warning' : 'error'}
                  />
                </TableCell>
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 'medium',
                      background: 'linear-gradient(45deg, #1976d2, #42a5f5)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {shortenDate(expense.date)}
                  </Typography>
                </TableCell>
                {isManager && (
                  <TableCell>
                    {expense.status === 'Pending' && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          onClick={() => dispatch(approveExpense(expense.id))}
                          sx={{ mr: 1 }}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          onClick={() => dispatch(rejectExpense(expense.id))}
                        >
                          Reject
                        </Button>
                      </>
                    )}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {isManager && <PdfExport expenses={expenses} />}
    </Box>
  );
};

export default ExpenseList;